export default "__VITE_ASSET__59a85e15__"